import React, {Component} from "react";

export default class FloodMarker extends Component {

    constructor() {
        super();
        this.state = {};
    }

    render() {
        let icon = this.getIcon();
        return <div style={{
            display: "flex", flexDirection: "column", alignItems: "center", position: "absolute",
            transform: "translate(-50%, -100%)"
        }}>
            <img onClick={() => this.props.clicked(this.props.flood)} style={{width: 24, height: 24}}
                 src={require("../icons/" + icon + ".png")}/>
        </div>;
    }

    getIcon = () => {
        const type = 4 - this.props.flood.severity;
        return "flood" + type;
    };

}
